export const businessChannelNames = (businessId, usePrivateChannels)=>usePrivateChannels ? {
        businessId,
        mgmt: "private-".concat(businessId),
        scout: "private-".concat(businessId, "-scout")
    } : {
        businessId,
        mgmt: businessId,
        scout: "".concat(businessId, "-scout")
    };
